import { Navigate } from 'react-router-dom';

export const AuthGaurd: React.FC = ({ children }) => {
    const token = localStorage.getItem('token');
    if (!token) {
        return <Navigate to='/login' />;
    }
    return <>{children}</>;
};
